import { motion } from "framer-motion";

/**
 * Decorative background used on every page (orbs, soft grid, grain).
 * Matches the original design guidelines: cream → blush light theme.
 */
export default function PageBackground() {
  return (
    <div className="pointer-events-none absolute inset-0 z-0">
      <div className="glow-orb absolute -left-32 top-1/4 h-[420px] w-[420px] rounded-full bg-rose-300/45 blur-[120px] md:h-[560px] md:w-[560px]" />
      <div className="glow-orb absolute right-[-12%] top-[-8%] h-[320px] w-[320px] rounded-full bg-amber-100/70 blur-[100px] md:h-[460px] md:w-[460px]" />
      <div className="glow-orb absolute bottom-[-15%] left-1/3 h-[300px] w-[420px] rounded-full bg-pink-200/55 blur-[120px] md:h-[420px] md:w-[620px]" />

      <svg
        className="absolute inset-0 h-full w-full opacity-[0.05]"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern id="grid" width="56" height="56" patternUnits="userSpaceOnUse">
            <path
              d="M 56 0 L 0 0 0 56"
              fill="none"
              stroke="#1a1a24"
              strokeWidth="0.5"
            />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#grid)" />
      </svg>

      <div
        className="absolute inset-0 opacity-[0.08] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='160' height='160'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.5 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")",
        }}
      />
    </div>
  );
}

/**
 * Soft page footer reused across all routes.
 */
export function PageFooter() {
  return (
    <motion.footer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1, delay: 0.6 }}
      className="relative z-10 flex flex-col items-start justify-between gap-4 px-5 pb-8 text-[10px] uppercase tracking-[0.22em] text-slate-500 md:flex-row md:items-center md:px-12 md:text-[11px] lg:px-16"
      data-testid="page-footer"
    >
      <div>© {new Date().getFullYear()} Mishenka Iskandera · Apex with grace</div>
      <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
        <span>Partners</span>
        <span className="font-display text-slate-700">BMW M</span>
        <span className="font-display text-slate-700">FANATEC</span>
        <span className="font-display text-slate-700">ASSETTO</span>
      </div>
    </motion.footer>
  );
}
